import { Plus } from 'lucide-react'
import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface AddButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
}

/**
 * Standard "Dodaj/Nowa X" button used in table headers across the app.
 * Sky-600 background, Plus icon, small size.
 */
export function AddButton({ children, className, ...rest }: AddButtonProps) {
  return (
    <button
      type="button"
      {...rest}
      className={cn(
        'inline-flex items-center gap-1 rounded bg-sky-600 px-3 py-1.5 text-sm text-white whitespace-nowrap',
        'hover:bg-sky-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors',
        className,
      )}
    >
      <Plus className="size-3.5" aria-hidden />
      <span>{children}</span>
    </button>
  )
}
